"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToDeposits = exports.submittingDepositTravelRule = exports.submittingDeposit = exports.submitDepositTravelRuleInfo = exports.requestDepositTickets = exports.receiveDepositTravelRuleResult = exports.receiveDepositTickets = exports.receiveDepositTicket = exports.receiveDepositTemplates = exports.receiveDepositTemplate = exports.receiveDepositInfo = exports.getDepositTickets = exports.getDepositInfo = exports.fetchingDepositTemplates = exports.fetchingDepositTemplate = exports.fetchingDepositInfo = exports.fetchProductDepositTemplate = exports.fetchAllProductDepositTemplates = exports.depositTemplatesError = exports.depositTemplateError = exports.depositInfoError = exports.createDepositTicket = exports.addDeposit = exports.SUBMITTING_DEPOSIT_TRAVEL_RULE = exports.SUBMITTING_DEPOSIT = exports.RETAIL_FIAT_CONFIRM_DEPOSIT = exports.RESET_DEPOSIT_INFO = exports.REQUEST_DEPOSIT_TICKETS = exports.RECEIVE_DEPOSIT_TRAVEL_RULE_RESULT = exports.RECEIVE_DEPOSIT_TICKETS = exports.RECEIVE_DEPOSIT_TICKET = exports.RECEIVE_DEPOSIT_TEMPLATE_ERROR = exports.RECEIVE_DEPOSIT_TEMPLATES_ERROR = exports.RECEIVE_DEPOSIT_TEMPLATES = exports.RECEIVE_DEPOSIT_TEMPLATE = exports.RECEIVE_DEPOSIT_INFO_ERROR = exports.RECEIVE_DEPOSIT_INFO = exports.FETCH_PRODUCT_DEPOSIT_TEMPLATES = exports.FETCH_PRODUCT_DEPOSIT_TEMPLATE = exports.FETCH_DEPOSIT_INFO = exports.ADD_DEPOSIT = void 0;
var _apiActions = require("./apiActions");
var _depositSubscriptionService = _interopRequireDefault(require("../../services/subscriptions/depositSubscriptionService"));
var _snackbarActions = require("./snackbarActions");
var _sidePaneActions = require("./sidePaneActions");
var _errorTextFormatter = require("../../helpers/errorTextFormatter");
var _config = _interopRequireDefault(require("../../config"));
var _excluded = ["ProductId", "amount"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var FETCH_PRODUCT_DEPOSIT_TEMPLATES = exports.FETCH_PRODUCT_DEPOSIT_TEMPLATES = 'FETCH_PRODUCT_DEPOSIT_TEMPLATES';
var FETCH_PRODUCT_DEPOSIT_TEMPLATE = exports.FETCH_PRODUCT_DEPOSIT_TEMPLATE = 'FETCH_PRODUCT_DEPOSIT_TEMPLATE';
var RECEIVE_DEPOSIT_TEMPLATES = exports.RECEIVE_DEPOSIT_TEMPLATES = 'RECEIVE_DEPOSIT_TEMPLATES';
var RECEIVE_DEPOSIT_TEMPLATES_ERROR = exports.RECEIVE_DEPOSIT_TEMPLATES_ERROR = 'RECEIVE_DEPOSIT_TEMPLATES_ERROR';
var RECEIVE_DEPOSIT_TEMPLATE = exports.RECEIVE_DEPOSIT_TEMPLATE = 'RECEIVE_DEPOSIT_TEMPLATE';
var RECEIVE_DEPOSIT_TEMPLATE_ERROR = exports.RECEIVE_DEPOSIT_TEMPLATE_ERROR = 'RECEIVE_DEPOSIT_TEMPLATE_ERROR';
var RECEIVE_DEPOSIT_INFO_ERROR = exports.RECEIVE_DEPOSIT_INFO_ERROR = 'RECEIVE_DEPOSIT_INFO_ERROR';
var SUBMITTING_DEPOSIT = exports.SUBMITTING_DEPOSIT = 'SUBMITTING_DEPOSIT';
var FETCH_DEPOSIT_INFO = exports.FETCH_DEPOSIT_INFO = 'FETCH_DEPOSIT_INFO';
var RECEIVE_DEPOSIT_INFO = exports.RECEIVE_DEPOSIT_INFO = 'RECEIVE_DEPOSIT_INFO';
var RECEIVE_DEPOSIT_TICKET = exports.RECEIVE_DEPOSIT_TICKET = 'RECEIVE_DEPOSIT_TICKET';
var RECEIVE_DEPOSIT_TICKETS = exports.RECEIVE_DEPOSIT_TICKETS = 'RECEIVE_DEPOSIT_TICKETS';
var RESET_DEPOSIT_INFO = exports.RESET_DEPOSIT_INFO = 'RESET_DEPOSIT_INFO';
var RETAIL_FIAT_CONFIRM_DEPOSIT = exports.RETAIL_FIAT_CONFIRM_DEPOSIT = 'RETAIL_FIAT_CONFIRM_DEPOSIT';
var ADD_DEPOSIT = exports.ADD_DEPOSIT = 'ADD_DEPOSIT';
var REQUEST_DEPOSIT_TICKETS = exports.REQUEST_DEPOSIT_TICKETS = 'REQUEST_DEPOSIT_TICKETS';
var SUBMITTING_DEPOSIT_TRAVEL_RULE = exports.SUBMITTING_DEPOSIT_TRAVEL_RULE = 'SUBMITTING_DEPOSIT_TRAVEL_RULE';
var RECEIVE_DEPOSIT_TRAVEL_RULE_RESULT = exports.RECEIVE_DEPOSIT_TRAVEL_RULE_RESULT = 'RECEIVE_DEPOSIT_TRAVEL_RULE_RESULT';
var fetchAllProductDepositTemplates = exports.fetchAllProductDepositTemplates = function fetchAllProductDepositTemplates(ProductId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch, getState) {
      var payload, data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!isNaN(ProductId)) {
              _context.n = 1;
              break;
            }
            return _context.a(2, dispatch({
              type: RESET_DEPOSIT_INFO
            }));
          case 1:
            dispatch(fetchingDepositTemplates(ProductId));
            payload = {
              ProductId: ProductId,
              OMSId: getState().user.userInfo.OMSId,
              AccountId: getState().user.selectedAccountId
            };
            _context.n = 2;
            return dispatch((0, _apiActions.callAPI)('GetDepositTemplateTypes', payload))["catch"](function () {
              return dispatch(fetchProductDepositTemplate(ProductId));
            });
          case 2:
            data = _context.v;
            _context.p = 3;
            if (!data.result) {
              _context.n = 5;
              break;
            }
            if (!(data.TemplateTypes && !data.TemplateTypes.length)) {
              _context.n = 4;
              break;
            }
            return _context.a(2, dispatch(depositTemplatesError('There are no providers configured for this product')));
          case 4:
            dispatch(receiveDepositTemplates(data.TemplateTypes));
            if (data.TemplateTypes && data.TemplateTypes.length === 1) {
              dispatch(fetchProductDepositTemplate(ProductId, data.TemplateTypes[0].AccountProviderId));
            }
            return _context.a(2, true);
          case 5:
            return _context.a(2, dispatch(depositTemplatesError(data.errormsg)));
          case 6:
            _context.p = 6;
            _t = _context.v;
            dispatch(fetchProductDepositTemplate(ProductId));
          case 7:
            return _context.a(2);
        }
      }, _callee, null, [[3, 6]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var fetchProductDepositTemplate = exports.fetchProductDepositTemplate = function fetchProductDepositTemplate(ProductId, AccountProviderId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch, getState) {
      var payload, data, _data$Template, UseGetDepositWorkflow, Template, DepositWorkflow;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (!isNaN(ProductId)) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2, dispatch({
              type: RESET_DEPOSIT_INFO
            }));
          case 1:
            dispatch(fetchingDepositTemplate(ProductId, AccountProviderId));
            payload = {
              OMSId: getState().user.userInfo.OMSId,
              AccountId: getState().user.selectedAccountId,
              ProductId: ProductId,
              AccountProviderId: AccountProviderId
            };
            _context2.n = 2;
            return dispatch((0, _apiActions.callAPI)('GetDepositRequestInfoTemplate', payload));
          case 2:
            data = _context2.v;
            if (!(data && data.result)) {
              _context2.n = 4;
              break;
            }
            _data$Template = data.Template, UseGetDepositWorkflow = _data$Template.UseGetDepositWorkflow, Template = _data$Template.Template, DepositWorkflow = _data$Template.DepositWorkflow;
            if (UseGetDepositWorkflow || DepositWorkflow === 'CryptoWallet') {
              dispatch(getDepositInfo(ProductId));
            } else {
              dispatch(depositInfoError('Failed to load'));
            }
            if (Template) {
              _context2.n = 3;
              break;
            }
            return _context2.a(2, dispatch(depositTemplateError('Server provided an unexpected response')));
          case 3:
            return _context2.a(2, dispatch(receiveDepositTemplate(data)));
          case 4:
            return _context2.a(2, dispatch(depositTemplateError(data ? data.errormsg : 'Internal error')));
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var getDepositInfo = exports.getDepositInfo = function getDepositInfo(ProductId, template, accountProviderId) {
  var generateNewKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _config["default"].Deposit.generateNewKey;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch, getState) {
      var productIdNum, OMSId, AccountId, templateType, templateTypeObj, payload, depositInfo, data;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            productIdNum = Number(ProductId);
            if (!(!Number.isFinite(productIdNum) || productIdNum <= 0)) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2, dispatch({
              type: RESET_DEPOSIT_INFO
            }));
          case 1:
            OMSId = getState().user.userInfo.OMSId;
            AccountId = getState().user.selectedAccountId;
            templateType = getState().deposit.AccountProviderId;
            templateTypeObj = getState().deposit.templateTypes.find(function (template) {
              return template.AccountProviderId === templateType;
            });
            payload = {
              OMSId: OMSId,
              AccountId: AccountId,
              ProductId: productIdNum,
              GenerateNewKey: generateNewKey
            };
            if (templateTypeObj) {
              payload.AccountProviderId = templateTypeObj.AccountProviderId;
            }
            if (accountProviderId) {
              payload.AccountProviderId = accountProviderId;
            }
            if (template) {
              payload.DepositInfo = template;
            }
            dispatch(fetchingDepositInfo(ProductId));
            _context3.n = 2;
            return dispatch((0, _apiActions.callAPI)('GetDepositInfo', payload));
          case 2:
            depositInfo = _context3.v;
            if (depositInfo) {
              _context3.n = 3;
              break;
            }
            return _context3.a(2, dispatch(depositInfoError('No deposit addresses available for this provider.')));
          case 3:
            if (!depositInfo.result) {
              _context3.n = 4;
              break;
            }
            try {
              data = JSON.parse(depositInfo.DepositInfo);
            } catch (e) {
              console.log(e);
              data = [depositInfo.DepositInfo];
            }
            return _context3.a(2, dispatch(receiveDepositInfo(data)));
          case 4:
            return _context3.a(2, dispatch(depositInfoError(depositInfo.errormsg)));
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var getDepositTickets = exports.getDepositTickets = function getDepositTickets() {
  var StartIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var OMSId, AccountId, depositTickets, modifiedTickets;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            dispatch(requestDepositTickets({
              StartIndex: StartIndex
            }));
            OMSId = getState().user.userInfo.OMSId;
            AccountId = getState().user.selectedAccountId;
            _context4.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetDepositTickets', {
              OMSId: OMSId,
              AccountId: AccountId,
              OperatorId: 1,
              StartIndex: StartIndex
            }));
          case 1:
            depositTickets = _context4.v;
            // Temporarily inject AmlTravelRulePendingUserInput status into every other row
            modifiedTickets = depositTickets.map(function (ticket, index) {
              return index % 2 === 0 ? _objectSpread(_objectSpread({}, ticket), {}, {
                Status: 'AmlTravelRulePendingUserInput'
              }) : ticket;
            });
            return _context4.a(2, dispatch(receiveDepositTickets(modifiedTickets)));
        }
      }, _callee4);
    }));
    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var createDepositTicket = exports.createDepositTicket = function createDepositTicket(_ref5) {
  var ProductId = _ref5.ProductId,
    amount = _ref5.amount,
    info = _objectWithoutProperties(_ref5, _excluded);
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch, getState) {
      var OMSId, AccountId, UseGetDepositWorkflow, DepositInfo, AccountProviderId, payload, depositStatus;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            AccountId = getState().user.selectedAccountId;
            UseGetDepositWorkflow = getState().deposit.templateInfo.UseGetDepositWorkflow;
            DepositInfo = JSON.stringify(info);
            AccountProviderId = getState().deposit.AccountProviderId;
            payload = {
              OMSId: OMSId,
              OperatorId: 1,
              AccountId: AccountId,
              AccountProviderId: AccountProviderId,
              RequestUser: AccountId,
              AssetId: +ProductId,
              Amount: amount ? amount : +info.Amount,
              DepositInfo: DepositInfo,
              Status: 'New'
            };
            dispatch(submittingDeposit);
            if (!UseGetDepositWorkflow) {
              _context5.n = 1;
              break;
            }
            return _context5.a(2, dispatch(getDepositInfo(ProductId, DepositInfo)));
          case 1:
            _context5.n = 2;
            return dispatch((0, _apiActions.callAPI)('CreateDepositTicket', payload));
          case 2:
            depositStatus = _context5.v;
            if (!(depositStatus.result === false)) {
              _context5.n = 3;
              break;
            }
            return _context5.a(2, dispatch((0, _snackbarActions.showSnack)({
              id: 'depositRejectSnack',
              text: (0, _errorTextFormatter.formatErrorText)(depositStatus),
              type: 'warning'
            })));
          case 3:
            dispatch((0, _sidePaneActions.closeDepositSidePane)());
            // t('Your deposit has been successfully added')
            dispatch(getDepositTickets());
            if (!_config["default"].Deposit.showDepositIdModal) {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'depositSuccessSnack',
                text: 'Your deposit has been successfully added',
                type: 'success'
              }));
            }
            return _context5.a(2, dispatch(receiveDepositTicket(depositStatus)));
        }
      }, _callee5);
    }));
    return function (_x9, _x0) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var subscribeToDeposits = exports.subscribeToDeposits = function subscribeToDeposits() {
  return function (dispatch) {
    _depositSubscriptionService["default"].subscribe(function (updates) {
      dispatch(addDeposit(updates));
    });
  };
};
var addDeposit = exports.addDeposit = function addDeposit(payload) {
  return {
    type: ADD_DEPOSIT,
    payload: payload
  };
};
var fetchingDepositTemplates = exports.fetchingDepositTemplates = function fetchingDepositTemplates(product) {
  return {
    type: FETCH_PRODUCT_DEPOSIT_TEMPLATES,
    payload: {
      product: product
    }
  };
};
var fetchingDepositTemplate = exports.fetchingDepositTemplate = function fetchingDepositTemplate(product, AccountProviderId) {
  return {
    type: FETCH_PRODUCT_DEPOSIT_TEMPLATE,
    payload: {
      product: product,
      AccountProviderId: AccountProviderId
    }
  };
};
var fetchingDepositInfo = exports.fetchingDepositInfo = function fetchingDepositInfo(product) {
  return {
    type: FETCH_DEPOSIT_INFO,
    payload: {
      product: product
    }
  };
};
var receiveDepositTemplates = exports.receiveDepositTemplates = function receiveDepositTemplates(payload) {
  return {
    type: RECEIVE_DEPOSIT_TEMPLATES,
    payload: payload
  };
};
var requestDepositTickets = exports.requestDepositTickets = function requestDepositTickets(payload) {
  return {
    type: REQUEST_DEPOSIT_TICKETS,
    payload: payload
  };
};
var receiveDepositTemplate = exports.receiveDepositTemplate = function receiveDepositTemplate(payload) {
  return {
    type: RECEIVE_DEPOSIT_TEMPLATE,
    payload: payload
  };
};
var depositTemplatesError = exports.depositTemplatesError = function depositTemplatesError(payload) {
  return {
    type: RECEIVE_DEPOSIT_TEMPLATES_ERROR,
    payload: payload
  };
};
var depositTemplateError = exports.depositTemplateError = function depositTemplateError(payload) {
  return {
    type: RECEIVE_DEPOSIT_TEMPLATE_ERROR,
    payload: payload
  };
};
var depositInfoError = exports.depositInfoError = function depositInfoError(payload) {
  return {
    type: RECEIVE_DEPOSIT_INFO_ERROR,
    payload: payload
  };
};
var submittingDeposit = exports.submittingDeposit = {
  type: SUBMITTING_DEPOSIT
};
var receiveDepositInfo = exports.receiveDepositInfo = function receiveDepositInfo(payload) {
  return {
    type: RECEIVE_DEPOSIT_INFO,
    payload: payload
  };
};
var receiveDepositTicket = exports.receiveDepositTicket = function receiveDepositTicket(payload) {
  return {
    type: RECEIVE_DEPOSIT_TICKET,
    payload: payload
  };
};
var receiveDepositTickets = exports.receiveDepositTickets = function receiveDepositTickets(payload) {
  return {
    type: RECEIVE_DEPOSIT_TICKETS,
    payload: payload
  };
};

// DEV-8959: Travel Rule deposit originator information submission
var submittingDepositTravelRule = exports.submittingDepositTravelRule = {
  type: SUBMITTING_DEPOSIT_TRAVEL_RULE
};
var receiveDepositTravelRuleResult = exports.receiveDepositTravelRuleResult = function receiveDepositTravelRuleResult(payload) {
  return {
    type: RECEIVE_DEPOSIT_TRAVEL_RULE_RESULT,
    payload: payload
  };
};
var submitDepositTravelRuleInfo = exports.submitDepositTravelRuleInfo = function submitDepositTravelRuleInfo(_ref7) {
  var TicketId = _ref7.TicketId,
    SourceType = _ref7.SourceType,
    ExchangeName = _ref7.ExchangeName,
    SenderFirstName = _ref7.SenderFirstName,
    SenderLastName = _ref7.SenderLastName,
    SenderDob = _ref7.SenderDob,
    SenderCountry = _ref7.SenderCountry,
    IsSelfSender = _ref7.IsSelfSender;
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(dispatch, getState) {
      var OMSId, payload, result;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            dispatch(submittingDepositTravelRule);
            OMSId = getState().user.userInfo.OMSId;
            payload = {
              OMSId: OMSId,
              TicketId: TicketId,
              SourceType: SourceType,
              ExchangeName: SourceType === 'exchange' ? ExchangeName : '',
              SenderFirstName: SenderFirstName,
              SenderLastName: SenderLastName,
              SenderDob: SenderDob || '',
              SenderCountry: SenderCountry || '',
              IsSelfSender: IsSelfSender || false
            };
            _context6.n = 1;
            return dispatch((0, _apiActions.callAPI)('SubmitDepositTravelRuleInfo', payload));
          case 1:
            result = _context6.v;
            if (!(result.result === false)) {
              _context6.n = 2;
              break;
            }
            dispatch((0, _snackbarActions.showSnack)({
              id: 'depositTravelRuleErrorSnack',
              text: (0, _errorTextFormatter.formatErrorText)(result),
              type: 'warning'
            }));
            return _context6.a(2, dispatch(receiveDepositTravelRuleResult({
              success: false,
              error: result.errormsg
            })));
          case 2:
            dispatch((0, _snackbarActions.showSnack)({
              id: 'depositTravelRuleSuccessSnack',
              // t('Travel Rule information submitted successfully')
              text: 'Travel Rule information submitted successfully',
              type: 'success'
            }));

            // Refresh deposit tickets to show updated status
            dispatch(getDepositTickets());
            return _context6.a(2, dispatch(receiveDepositTravelRuleResult({
              success: true,
              ticketId: result.TicketId,
              newStatus: result.NewStatus
            })));
        }
      }, _callee6);
    }));
    return function (_x1, _x10) {
      return _ref8.apply(this, arguments);
    };
  }();
};